import Icon, { IconType } from '@/components/Icon';
import { LOCALE_LINKS, useLocale } from '@/helpers/LangHelper';

import styles from './Auth.module.scss';

const Auth = () => {
  const { locale } = useLocale();
  const portal = LOCALE_LINKS[locale]?.portal;

  return (
    <div className={styles.authcontainer}>
      <div className={styles.ctaContainer}>
        <div className={styles.buttonContainer}>
          <a className={styles.buttonsIcon} href={`${portal?.home}${portal?.login}`}>
            <Icon type={IconType.Profile} />
            <span className={styles.loginButtonLabel}>Login</span>
          </a>
        </div>
        <div className={styles.buttonContainer}>
          <a className={styles.buttonsNavigation} href={`${portal?.home}${portal?.signup}`}>
            Sign Up
          </a>
        </div>
      </div>
    </div>
  );
};

export default Auth;
